var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiamondsFront2 = function SvgDiamondsFront2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 120,
    fill: "none",
    viewBox: "0 0 80 120"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5311_3807)",
    d: "M6 1.887 7.838 0l1.838 1.887-1.838 1.887z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5311_3807)",
    d: "m6 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5311_3807)",
    d: "m6 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5311_3807)",
    d: "m6 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5311_3807)",
    d: "m6 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5311_3807)",
    d: "m6 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5311_3807)",
    d: "m6 58.5 1.838-1.887L9.676 58.5l-1.838 1.887z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5311_3807)",
    d: "m6 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5311_3807)",
    d: "m6 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5311_3807)",
    d: "m6 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5311_3807)",
    d: "m6 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_5311_3807)",
    d: "m6 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_5311_3807)",
    d: "m6 115.113 1.838-1.887 1.838 1.887L7.838 117z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_5311_3807)",
    d: "M15.19 1.887 17.026 0l1.838 1.887-1.838 1.887z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_5311_3807)",
    d: "m15.19 11.323 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5311_3807)",
    d: "m15.19 20.758 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_5311_3807)",
    d: "m15.19 30.194 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint17_linear_5311_3807)",
    d: "m15.19 39.629 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint18_linear_5311_3807)",
    d: "m15.19 49.065 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint19_linear_5311_3807)",
    d: "m15.19 58.5 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint20_linear_5311_3807)",
    d: "m15.19 67.936 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint21_linear_5311_3807)",
    d: "m15.19 77.371 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint22_linear_5311_3807)",
    d: "m15.19 86.806 1.837-1.887 1.838 1.887-1.838 1.888z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint23_linear_5311_3807)",
    d: "m15.19 96.242 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint24_linear_5311_3807)",
    d: "m15.19 105.677 1.837-1.887 1.838 1.887-1.838 1.888z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint25_linear_5311_3807)",
    d: "m15.19 115.113 1.837-1.887 1.838 1.887L17.027 117z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint26_linear_5311_3807)",
    d: "M24.378 1.887 26.216 0l1.838 1.887-1.838 1.887z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint27_linear_5311_3807)",
    d: "m24.378 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint28_linear_5311_3807)",
    d: "m24.378 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint29_linear_5311_3807)",
    d: "m24.378 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint30_linear_5311_3807)",
    d: "m24.378 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint31_linear_5311_3807)",
    d: "m24.378 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint32_linear_5311_3807)",
    d: "m24.378 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint33_linear_5311_3807)",
    d: "m24.378 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint34_linear_5311_3807)",
    d: "m24.378 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint35_linear_5311_3807)",
    d: "m24.378 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint36_linear_5311_3807)",
    d: "m24.378 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint37_linear_5311_3807)",
    d: "m24.378 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint38_linear_5311_3807)",
    d: "m24.378 115.113 1.838-1.887 1.838 1.887L26.216 117z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint39_linear_5311_3807)",
    d: "M33.568 1.887 35.405 0l1.838 1.887-1.838 1.887z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint40_linear_5311_3807)",
    d: "m33.568 11.323 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint41_linear_5311_3807)",
    d: "m33.568 20.758 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint42_linear_5311_3807)",
    d: "m33.568 30.194 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint43_linear_5311_3807)",
    d: "m33.568 39.629 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint44_linear_5311_3807)",
    d: "m33.568 49.065 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint45_linear_5311_3807)",
    d: "m33.568 58.5 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint46_linear_5311_3807)",
    d: "m33.568 67.936 1.837-1.888 1.838 1.888-1.838 1.887z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint47_linear_5311_3807)",
    d: "m33.568 77.371 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint48_linear_5311_3807)",
    d: "m33.568 86.806 1.837-1.887 1.838 1.887-1.838 1.888z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint49_linear_5311_3807)",
    d: "m33.568 96.242 1.837-1.887 1.838 1.887-1.838 1.887z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint50_linear_5311_3807)",
    d: "m33.568 105.677 1.837-1.887 1.838 1.887-1.838 1.888z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint51_linear_5311_3807)",
    d: "m33.568 115.113 1.837-1.887 1.838 1.887L35.405 117z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint52_linear_5311_3807)",
    d: "M42.757 1.887 44.595 0l1.837 1.887-1.837 1.887z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint53_linear_5311_3807)",
    d: "m42.757 11.323 1.838-1.888 1.837 1.888-1.837 1.887z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint54_linear_5311_3807)",
    d: "m42.757 20.758 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint55_linear_5311_3807)",
    d: "m42.757 30.194 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint56_linear_5311_3807)",
    d: "m42.757 39.629 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint57_linear_5311_3807)",
    d: "m42.757 49.065 1.838-1.888 1.837 1.888-1.837 1.887z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint58_linear_5311_3807)",
    d: "m42.757 58.5 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint59_linear_5311_3807)",
    d: "m42.757 67.936 1.838-1.888 1.837 1.888-1.837 1.887z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint60_linear_5311_3807)",
    d: "m42.757 77.371 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint61_linear_5311_3807)",
    d: "m42.757 86.806 1.838-1.887 1.837 1.887-1.837 1.888z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint62_linear_5311_3807)",
    d: "m42.757 96.242 1.838-1.887 1.837 1.887-1.837 1.887z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint63_linear_5311_3807)",
    d: "m42.757 105.677 1.838-1.887 1.837 1.887-1.837 1.888z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint64_linear_5311_3807)",
    d: "m42.757 115.113 1.838-1.887 1.837 1.887L44.595 117z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint65_linear_5311_3807)",
    d: "M51.946 1.887 53.784 0l1.838 1.887-1.838 1.887z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint66_linear_5311_3807)",
    d: "m51.946 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint67_linear_5311_3807)",
    d: "m51.946 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint68_linear_5311_3807)",
    d: "m51.946 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint69_linear_5311_3807)",
    d: "m51.946 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint70_linear_5311_3807)",
    d: "m51.946 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint71_linear_5311_3807)",
    d: "m51.946 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint72_linear_5311_3807)",
    d: "m51.946 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint73_linear_5311_3807)",
    d: "m51.946 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint74_linear_5311_3807)",
    d: "m51.946 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint75_linear_5311_3807)",
    d: "m51.946 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint76_linear_5311_3807)",
    d: "m51.946 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint77_linear_5311_3807)",
    d: "m51.946 115.113 1.838-1.887 1.838 1.887L53.784 117z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint78_linear_5311_3807)",
    d: "M61.135 1.887 62.973 0l1.838 1.887-1.838 1.887z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint79_linear_5311_3807)",
    d: "m61.135 11.323 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint80_linear_5311_3807)",
    d: "m61.135 20.758 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint81_linear_5311_3807)",
    d: "m61.135 30.194 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint82_linear_5311_3807)",
    d: "m61.135 39.629 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint83_linear_5311_3807)",
    d: "m61.135 49.065 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint84_linear_5311_3807)",
    d: "m61.135 58.5 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint85_linear_5311_3807)",
    d: "m61.135 67.936 1.838-1.888 1.838 1.888-1.838 1.887z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint86_linear_5311_3807)",
    d: "m61.135 77.371 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint87_linear_5311_3807)",
    d: "m61.135 86.806 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint88_linear_5311_3807)",
    d: "m61.135 96.242 1.838-1.887 1.838 1.887-1.838 1.887z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint89_linear_5311_3807)",
    d: "m61.135 105.677 1.838-1.887 1.838 1.887-1.838 1.888z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint90_linear_5311_3807)",
    d: "m61.135 115.113 1.838-1.887 1.838 1.887L62.973 117z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint91_linear_5311_3807)",
    d: "M70.324 1.887 72.162 0 74 1.887l-1.838 1.887z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint92_linear_5311_3807)",
    d: "m70.324 11.323 1.838-1.888L74 11.323l-1.838 1.887z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint93_linear_5311_3807)",
    d: "m70.324 20.758 1.838-1.887L74 20.758l-1.838 1.887z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint94_linear_5311_3807)",
    d: "m70.324 30.194 1.838-1.887L74 30.194l-1.838 1.887z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint95_linear_5311_3807)",
    d: "m70.324 39.629 1.838-1.887L74 39.629l-1.838 1.887z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint96_linear_5311_3807)",
    d: "m70.324 49.065 1.838-1.888L74 49.065l-1.838 1.887z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint97_linear_5311_3807)",
    d: "m70.324 58.5 1.838-1.887L74 58.5l-1.838 1.887z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint98_linear_5311_3807)",
    d: "m70.324 67.936 1.838-1.888L74 67.936l-1.838 1.887z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint99_linear_5311_3807)",
    d: "m70.324 77.371 1.838-1.887L74 77.37l-1.838 1.887z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint100_linear_5311_3807)",
    d: "m70.324 86.806 1.838-1.887L74 86.806l-1.838 1.888z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint101_linear_5311_3807)",
    d: "m70.324 96.242 1.838-1.887L74 96.242l-1.838 1.887z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint102_linear_5311_3807)",
    d: "m70.324 105.677 1.838-1.887L74 105.677l-1.838 1.888z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint103_linear_5311_3807)",
    d: "m70.324 115.113 1.838-1.887L74 115.113 72.162 117z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint104_linear_5311_3807)",
    d: "M5.77 63.373c-1.026-1.554-1.027-3.472-.003-5.027l29.205-44.36c2.19-3.325 7.641-3.328 9.835-.005L74.23 58.55c1.025 1.553 1.027 3.472.003 5.026l-29.205 44.36c-2.19 3.325-7.641 3.328-9.835.005z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.264 59.877a1.72 1.72 0 0 1-.001-1.829l10.013-16.14c.75-1.21 2.62-1.21 3.372-.002l10.088 16.217c.352.565.352 1.263.001 1.829l-10.013 16.14c-.75 1.21-2.62 1.21-3.372.002z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 23.016,
    y2: 210.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_5311_3807",
    x1: 40,
    x2: 40,
    y1: 1.659,
    y2: 120.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E8FA"
  })))));
};
export default SvgDiamondsFront2;